import type { RootState } from '@appStore/store'

import { appSelectors } from '@appStore/reducers/app'
import { useAppSelector } from 'shared/hooks'

function selectHasTeam(state: RootState) {
	const { isTeamPlanAccessible, teamId } = appSelectors.persona(state) ?? {}
	return Boolean(isTeamPlanAccessible && teamId)
}

export const useIsEnable = () => useAppSelector(selectHasTeam)
